import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios';

const client = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Single in-flight refresh promise to prevent concurrent refresh races
let refreshPromise: Promise<void> | null = null;

async function refreshToken(): Promise<void> {
  await axios.post('/api/auth/refresh', {}, { withCredentials: true });
}

client.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!refreshPromise) {
        refreshPromise = refreshToken().finally(() => {
          refreshPromise = null;
        });
      }

      try {
        await refreshPromise;
        return client(originalRequest);
      } catch {
        // Refresh failed — caller handles the rejection
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default client;
